<template>
    <button-base style-type="transparent">
        <slot></slot>
    </button-base>
</template>
